module.exports = {"id":"193348","name":"Xherdan Shaqiri","rating":"82","photo":"./data/images/photos/2/193348.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["AD","MD","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/XherdanShaqiri0.json
// module id = 4369
// module chunks = 0